module.exports = __webpack_public_path__ + "static/media/FINAL_AT_LOGO.111aaa6d.png";